import { render } from "./EntryText.vue?vue&type=template&id=27b94b08"
import script from "./EntryText.vue?vue&type=script&lang=ts"
export * from "./EntryText.vue?vue&type=script&lang=ts"
script.render = render

export default script